import { AuxiliumComponent } from "../auxilium-component";

export default class Checkbox extends AuxiliumComponent {
	static observable = ["label", "value", "helper-text", "type", "name"];
	static observableBooleans = ["checked", "required", "disable-messages"];

	#Mappers = {};

	constructor() {
		super();

		this.InitializeValidationMessages();

		this.value ??= "true";

		this.#Mappers = {
			name: this.name,
			required: this.required
		};

		if (this.closest("form") && !this.#Mappers.name) { this.#Mappers.name = this.id || this.identifier; }
	}

	parsedCallback() {
		this.classList.add("checkbox__wrapper");

		const checkbox = document.createElementWithContents("input", null, {
			id: this.identifier,
			className: `input-field${this.type === "switch" ? " switch" : ""}`.trim(),
			type: "checkbox",
			checked: this.checked,
			value: this.value
		});

		checkbox.addEventListener("change", () => this.checked = checkbox.checked);

		Object.keys(this.#Mappers).filter(x => this.#Mappers[x])
			.forEach(key => checkbox.setAttribute(key, this.#Mappers[key] === true ? "" : this.#Mappers[key]));

		if (this.helperText) {
			this.prepend(document.createElementWithContents("div", this.helperText, {
				className: "input-field__helper-text"
			}));
		}

		if (this.label) { this.prepend(document.createElementWithContents("label", this.label, { htmlFor: this.identifier })); }
		else if (this.innerHTML.trim()) { this.prepend(document.createElementWithContents("label", this.childNodes, { htmlFor: this.identifier })); }

		this.prepend(checkbox);
	}

	checkValidity() {
		const input = this.querySelector("input"),
			isValid = input?.checkValidity() ?? false;

		this.validationMessage = this.GetValidationMessage(input);

		return isValid;
	}

	setInvalid(message) {
		this.querySelector(".input-field__validation-error")?.remove();

		const input = this.querySelector("input"),
			msgElement = document.createElementWithContents("div", message, { className: "input-field__validation-error" });

		if (!this.disableMessages) {
			if (Browser.GetFlavour() === "gov") {
				this.querySelector("input").insertAdjacentElement("beforebegin", msgElement);
			} else {
				this.appendChild(msgElement);
			}
		}

		input.classList.add("input-field__invalid");

		this.querySelectorAll(".input__bound").forEach(x => x.classList.add("input-field__invalid"));
	}

	reportValidity() {
		const validity = this.checkValidity();

		this.querySelector(".input-field__validation-error")?.remove();
		this.querySelectorAll(".input-field__invalid").forEach(x => x.removeClass("input-field__invalid"));

		if (!validity) {
			this.setInvalid(this.validationMessage);
		}

		return validity;
	}

	attributeChanged(name, _, newValue) {
		switch (name) {
			case "checked":
				this.querySelector("input").checked = this.IsAttributeValueTrue(newValue);
				break;
			case "helper-text": {
				const existing = this.querySelector(".input-field__helper-text");

				if (existing) {
					existing.textContent = newValue;
				} else {
					this.appendChild(document.createElementWithContents("div", newValue, {
						className: "input-field__helper-text"
					}));
				}
			}
				break;
		}
	}
}
